import { graphQLFetcher } from 'api';
import { getBookingDifferences } from 'api/queries/bookingDifferences';
import { useAuthContext } from 'context/AuthContext';
import { authHeaders } from 'utils/authHeaders';
import { CustomerOrder } from 'interfaces/booking';
import { BookingDifferencesResponse } from 'interfaces/notifications';
import { useCallback, useState } from 'react';

const useBookingDifferences = () => {
  const [data, setData] = useState<CustomerOrder[] | null>();
  const [errors, setErrors] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { authUser: user, loading: authLoading } = useAuthContext();

  const fetchData = useCallback(
    async (orderIdFromUrl?: string) => {
      if (authLoading || !user) return null;
      setData(null);

      const query = await getBookingDifferences();

      const variables = {
        orderIdFromUrl: orderIdFromUrl,
      };

      const headers = await authHeaders(user);

      graphQLFetcher<BookingDifferencesResponse>({
        query,
        variables,
        headers,
      })
        .then(response => {
          setIsLoading(false);
          if (response.bookingDifferences?.error?.errorCode) {
            setErrors('Internal error');
          }
          setData(response.bookingDifferences.order);
        })
        .catch(err => {
          setErrors(err);
          setIsLoading(false);
        });
    },
    [authLoading, user],
  );

  return {
    data,
    errors,
    isLoading,
    fetchData,
  };
};

export default useBookingDifferences;
